import PartyPopperIcon from '@atlaskit/icon-lab/core/party-popper';
import React from 'react';

export const SvgConfetti = () => (
  <PartyPopperIcon label="" testId="ads-refreshed-icon" />
);
